import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { EditorComponent } from '../../components/editor/editor.component';
import { BaseSmartInputComponent } from '../smart-input-string/base-smart-input.component';

@Component({
  selector: 'app-smart-input-rich-text',
  templateUrl: './smart-input-rich-text.component.html',
  styleUrls: ['./smart-input-rich-text.component.scss'],
  standalone: true,
  imports: [FormsModule, EditorComponent, ReactiveFormsModule, TranslateModule],
})
export class SmartInputRichTextComponent extends BaseSmartInputComponent<string> {
  onChange(value: string) {
    this.control().patchValue(value);
    this.control().markAsDirty();
  }
}
